import Logo from "./Logo";
import React from "react";
const Header = (props) => {
    return <div className="Header">
        <Logo/>
    </div>;
};

export default Header;
